export default __webpack_public_path__ + "static/media/img-0.1b301a94.jpg";